import React from 'react';
import { useUser } from '@clerk/clerk-react';
import { useTranslation } from 'react-i18next';
import { Scale, Users } from 'lucide-react';
import { NotificationBell } from '../../../components/Notifications';
import { useAttorney } from '../../context/AttorneyContext';
import markoAvatar from 'url:../../../assets/marko-avatar.png';

/**
 * Attorney Header Component
 * Top header bar for attorney dashboard
 */
function AttorneyHeader() {
  const { t } = useTranslation('attorney');
  const { user } = useUser();
  const { attorneyName, organizationName } = useAttorney();

  return (
    <header className="bg-gradient-to-r from-[#004d40] via-[#00695c] to-[#00796b] shadow-md z-20 h-16 fixed top-0 w-full">
      <div className="px-6 h-full flex items-center justify-between">
        {/* Left section - Logo and Title */}
        <div className="flex items-center gap-4">
          {/* MarkoTM Logo */}
          <a href="/attorney" className="flex items-center gap-3">
            <img
              src={markoAvatar}
              alt="MarkoTM"
              className="h-9 w-9 rounded-lg"
            />
            <div>
              <h1 className="text-lg font-bold text-white">Attorney Dashboard</h1>
              {organizationName && (
                <span className="text-xs text-white/60">{organizationName}</span>
              )}
            </div>
          </a>
        </div>

        {/* Right section */}
        <div className="flex items-center gap-4">
          <div className="text-white">
            <NotificationBell />
          </div>

          <div className="h-8 w-px bg-white/20 hidden sm:block"></div>

          <div className="flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <div className="text-sm font-medium text-white">
                {attorneyName || user?.firstName || 'Attorney'}
              </div>
              <div className="text-xs text-white/60">Attorney</div>
            </div>

            <div className="h-9 w-9 rounded-full bg-white/20 flex items-center justify-center overflow-hidden ring-2 ring-white/30">
              {user?.imageUrl ? (
                <img src={user.imageUrl} alt="Profile" className="h-full w-full object-cover" />
              ) : (
                <Users className="h-4 w-4 text-white" />
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default AttorneyHeader;
